import React from 'react';
import HelpContent from './HelpContent';
import preciosBaterias from 'img/precios_baterias.png';
import electromovilidad_buses from 'img/electromovilidad_buses.png';

const ElectromovilidadBusesHelp = () => (
  <HelpContent>
    <h1>Electromovilidad en buses del transporte público</h1>
    <p>
      Esta medida se basa en el recambio tecnológico en el sistema de buses RED en la region metropolitana, 
      considerando el reemplazo de buses propulsados por tecnología diésel, por buses propulsados por energía eléctrica.  
      En las regiones, esta medida se implementa con el recambio tecnológico de buses, considerando la creación de nuevos servicios de buses a base de energía eléctrica, como una alternativa a buses diésel.
    </p>

    <img src={electromovilidad_buses} alt="Electromovilidad transporte público" />
    <label>Figura: Electromovilidad buses </label>

    <p>
    <strong>Trayectoria 1:</strong>
    </p>
    <p>    
      Región Metropolitana: En 2030 el 50% del parque de buses RED y el 20% de buses urbanos distintos al sistema RED es eléctrico. 
      En 2035 el 100% del parque de buses RED y de buses urbanos distintos al sistema RED es eléctrico.
    </p>
    <p>
      Regiones: En 2030 el 5,1% del parque de buses urbanos es eléctrico. En 2035 el 50% del parque de buses urbanos es eléctrico y en 2040 el 100% del parque de buses es eléctrico.
    </p>  
  </HelpContent>
);

export default ElectromovilidadBusesHelp;
